<template>
  <div>
    <div v-if="!loadData" class="flex items-center justify-center q-py-lg">
      <q-spinner-gears size="40px" color="primary"></q-spinner-gears>
    </div>
    <div
      v-else-if="loadData && !Object.values(registrationData).length"
      class="flex full-width column items-center q-py-lg"
      style="padding: 30px 0"
    >
      <q-icon name="hide_source" class="q-mb-sm" size="40px" color="primary"></q-icon>
      <span class="block" style="font-size: 16px">No data</span>
    </div>
    <div v-else class="q-pt-md">
      <EnvRegistration
        class="q-mt-lg q-mb-lg"
        :registrationId="registrationId"
        :registrationData="registrationData"
        :existEnvironments="environments"
      />
      <q-tabs
        v-model="infoTab"
        inline-label
        content-class="justify-start"
        class="q-mb-sm widget-tabs"
        indicator-color="primary"
      >
        <q-tab name="externalDns" label="DNS records" />
        <q-tab v-if="uiConfig?.showFirewallRules" name="rules" label="Firewall Rule (EAR) Requests" />
      </q-tabs>
      <q-tab-panels v-model="infoTab" animated>
        <q-tab-panel name="externalDns" class="q-px-none q-py-none">
          <DnsRecords :registrationData="registrationData" mode="read" :registrationId="registrationId" />
        </q-tab-panel>
        <q-tab-panel v-if="uiConfig?.showFirewallRules" name="rules" class="q-px-none q-py-none">
          <EarWidget
            :registrationData="registrationData"
            :registrationId="registrationId"
            earType="source"
            mode="read"
          />
          <EarWidget
            :registrationData="registrationData"
            :registrationId="registrationId"
            earType="target"
            mode="read"
          />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
  <AccessProductsTable :accessProducts="accessProducts" :loadAccessProducts="loadAccessProducts"></AccessProductsTable>
  <VirtualApisTable :virtualApis="virtualApis" :loadAccessProducts="loadAccessProducts"></VirtualApisTable>
  <span class="label-block q-mt-md" v-if="Object.values(infraService.links).length">Links:</span>
  <div class="links" v-if="Object.values(infraService.links).length">
    <Links :infraService="infraService" />
  </div>
</template>

<script>
import AccessProductsTable from '@/pages/digitalService/components/AccessProductsTable.vue';
import * as uiConfig from '@/shared/ui-config.json';
import { getRegistration } from '@/pages/registrations/api/api';
import EnvRegistration from '@/pages/registrations/components/EnvRegistration.vue';
import Links from './Links.vue';
import DnsRecords from './network/DnsRecords.vue';
import EarWidget from './ear/EarWidget.vue';
import VirtualApisTable from '@/pages/digitalService/components/VirtualApisTable.vue';

export default {
  name: 'NetworkWidget',
  components: {
    AccessProductsTable,
    DnsRecords,
    EarWidget,
    EnvRegistration,
    Links,
    VirtualApisTable,
  },
  props: {
    infraService: { type: Object },
    accessProducts: { type: Object },
    virtualApis: { type: Array },
    loadAccessProducts: { type: Boolean, default: () => false },
    registrationId: { type: String },
  },
  data() {
    return {
      tab: 'info',
      infoTab: 'externalDns',
      uiConfig: {},
      registrationData: {},
      envTab: undefined,
    };
  },
  async mounted() {
    this.uiConfig = uiConfig[process.env.VUE_APP_ENV];
    try {
      const data = await getRegistration(this.registrationId, true, false);
      this.environments = data.environments;
      this.registrationData.digitalServiceApm = data.digitalService.apmId;
      this.registrationData.infrastructureServiceApm = data.infraService.apmId;
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    } finally {
      this.loadData = true;
    }
  },
};
</script>

<style scoped lang="scss">
.table-info {
  border-bottom: none;
}
.active-tab {
  background-color: #edeff5;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.scrollable-table {
  overflow-x: auto; /* Enables horizontal scrolling */
  max-width: 100%; /* Prevents unnecessary stretching */
}
</style>
